import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiShield } from 'react-icons/fi';

const FootballCoverage = () => {
  const leagues = [
    'Premier League', 'Champions League', 'La Liga', 
    'Bundesliga', 'Serie A', 'MLS', 'Ligue 1', 'Eredivisie'
  ];

  return (
    <section id="leagues" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-black text-slate-900 mb-6 leading-tight">
              Deep Data for <br/>Your Project.
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Don't settle for static scores. Get access to the same high-tier data used by pros, ready to be dropped into your site layout.
            </p>
            <div className="grid grid-cols-2 gap-4 mb-8">
              {leagues.map(league => (
                <div key={league} className="flex items-center gap-3 p-3 bg-white rounded-xl border border-slate-200 shadow-sm">
                  <SafeIcon icon={FiCheckCircle} className="text-brand-500 w-5 h-5 flex-shrink-0" />
                  <span className="text-sm font-bold text-slate-700">{league}</span>
                </div>
              ))}
            </div>
            <p className="text-sm text-slate-400 font-medium">+ Over 100 more global football divisions</p>
          </div>
          
          <div className="relative">
            <div className="bg-slate-900 rounded-3xl p-8 shadow-2xl transform lg:rotate-2">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-red-500"></div>
                  <span className="text-white font-bold text-sm">LIVE: Arsenal 2 - 1 Chelsea</span>
                </div>
                <div className="text-brand-400 text-xs font-mono">74'</div>
              </div>
              <div className="space-y-4">
                <div className="h-2 bg-slate-800 rounded-full w-full">
                  <div className="h-2 bg-brand-500 rounded-full w-[65%] shadow-[0_0_10px_rgba(34,197,94,0.5)]"></div>
                </div>
                <div className="flex justify-between text-[10px] text-slate-500 uppercase font-bold tracking-widest">
                  <span>Possession</span>
                  <span>65% - 35%</span>
                </div>
                <div className="grid grid-cols-2 gap-3 mt-8">
                  <div className="h-16 bg-slate-800/50 rounded-xl border border-slate-700 flex flex-col items-center justify-center">
                    <span className="text-white font-bold">12</span>
                    <span className="text-[10px] text-slate-500 uppercase">Shots</span>
                  </div>
                  <div className="h-16 bg-slate-800/50 rounded-xl border border-slate-700 flex flex-col items-center justify-center">
                    <span className="text-white font-bold">5</span>
                    <span className="text-[10px] text-slate-500 uppercase">Corners</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-brand-500/20 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FootballCoverage;